<script> 
  import Gravatar from 'svelte-gravatar'

  export let user
  export let big = false
</script>

<div class:noPic={!user.pictureUrl} class:big={big}>
  {#if user.pictureUrl}
    <img src='{user.pictureUrl}' alt='{user.displayName} Picture'>
  {:else }
    <Gravatar email={user.email} default="identicon" size={big ? 96 : 32} />
  {/if}
</div>

<style>
  img {
    width:32px;
  }

  .big > img {
    width: 96px;
  }

  div {
    display:flex;
    width:32px;
    height:32px;
    justify-content: center;
    align-items: center;
    border-radius:50%;
    overflow: hidden;
  }

  div.big {
    width:96px;
    height:96px;
  }

  .noPic {
    background-color:white;
  }
</style>